import { useMemo } from 'react';

import type { ValidateRewardFailureCode } from '@order/graphql';
import { useLocalizationContext } from '@order/Localization';

import type { useSubmitOrderMutation } from '../../GraphQL/Checkout.generated';

export const useValidateRewardException = (
  submitResponse: ReturnType<typeof useSubmitOrderMutation>[0],
) => {
  const { t } = useLocalizationContext();
  const responseData = submitResponse?.data?.submitOrderUsingBillingAccount;
  const hasRewardError = responseData?.__typename === 'RewardNotValidated';

  const knownExceptions: Record<ValidateRewardFailureCode, string> = useMemo(
    () => ({
      REWARD_NOT_APPLICABLE: t('challenges.rewards.error.not-applicable'),
      LOYALTY_PROGRAM_UNAVAILABLE: t(
        'challenges.rewards.error.loyalty-program-unavailable',
      ),
      REWARD_EXPIRED: t('challenges.rewards.error.expired'),
      LOYALTY_NOT_PROCESSED: t(
        'challenges.rewards.error.loyalty-not-processed',
      ),
    }),
    [t],
  );

  return useMemo(() => {
    if (!hasRewardError) return undefined;

    const code = responseData?.failureCode;
    const message = knownExceptions?.[code];

    return { message };
  }, [hasRewardError, knownExceptions, responseData]);
};
